import * as t from "io-ts"

import {
    IFormData,
    ISupplementingInfo,
} from "../amendApplication/launchAmendmentTypes"
import {
    ApplicationSpec,
    FixedInputs,
    IGetSchemaMapper,
} from "../singleApplication/getSchemaTypes"

// Define our own form data and supplementing info types since they're not exported from amendments
const FormData = t.record(
    t.string,
    t.union([
        t.record(t.string, t.unknown),
        t.array(t.record(t.string, t.unknown)),
    ])
)

const SupplementingInfo = t.record(t.string, t.unknown)

// Define the raw draft data structure based on the API response
export const LaunchDraftRaw = t.type({
    completionStatus: t.number,
    formData: FormData,
    rawApplicationSpec: ApplicationSpec,
    supplementingInfo: SupplementingInfo,
    fixedInputs: FixedInputs,
    lcts: t.array(t.string),
    jurisdiction: t.string,
})

export type ILaunchDraftRaw = t.TypeOf<typeof LaunchDraftRaw>

// Extended type that includes the fields derived from the raw spec
export interface ILaunchDraftMapped extends IGetSchemaMapper {
    completionStatus: number
    formData: IFormData
    supplementingInfo: ISupplementingInfo
    lcts: string[]
    jurisdiction: string
    draftId?: string
}
